export default __webpack_public_path__ + "static/media/linear.475f6222.svg";